import { render, staticRenderFns } from "./homeStats.vue?vue&type=template&id=6b0655a6&scoped=true"
import script from "./homeStats.vue?vue&type=script&lang=js"
export * from "./homeStats.vue?vue&type=script&lang=js"
import style0 from "./homeStats.vue?vue&type=style&index=0&id=6b0655a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0655a6",
  null
  
)

export default component.exports